import { render, staticRenderFns } from "./CustomerDetails.vue?vue&type=template&id=3ec958be&scoped=true"
import script from "./CustomerDetails.vue?vue&type=script&lang=ts"
export * from "./CustomerDetails.vue?vue&type=script&lang=ts"
import style0 from "./CustomerDetails.vue?vue&type=style&index=0&id=3ec958be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec958be",
  null
  
)

export default component.exports